export default __webpack_public_path__ + "static/media/companyName.b1061a42.svg";